import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles({
  icon: {
    fontSize: 16,
  },
});

const InfoTooltip = ({ title, iconClassName, ...props }) => {
  const classes = useStyles();

  return (
    <Tooltip arrow placement="top" title={title} {...props}>
      <InfoIcon
        style={{ fontSize: 16 }}
        color="primary"
        className={clsx(classes.icon, iconClassName)}
      />
    </Tooltip>
  );
};

InfoTooltip.defaultProps = {
  iconClassName: undefined,
};

InfoTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  iconClassName: PropTypes.string,
};

export default InfoTooltip;
